import { Component, inject, OnInit } from "@angular/core";
import { ViewMode, FormText, FormGroup, FormBuilder } from "@coso/forms";
import { IEmailProfileHolder, SmtpType } from "@coso-replicator/core";
import { Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule as CosoFormsModule } from "@coso/forms";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AlertComponent } from "ngx-bootstrap/alert";
import { AlertMessageComponent } from "@coso/alert";
import { CommonModule } from "@angular/common";

@Component({
  templateUrl: "./add-edit-email-notification-profile-saas.component.html",
  imports: [CommonModule, CosoFormsModule, ReactiveFormsModule, FormsModule, AlertComponent, AlertMessageComponent],
  standalone: true
})
export class AddEditEmailNotificationProfileSaaSComponent implements OnInit {
  private fb = inject(FormBuilder);
  public activeModal = inject(NgbActiveModal);

  ViewMode = ViewMode;

  /** Initial state properties */
  viewMode: ViewMode;
  entity: IEmailProfileHolder;
  errorMessage: string;
  successMessage: string;

  saveCallback: (entity: IEmailProfileHolder) => void;
  sendTestEmailCallback: (entity: IEmailProfileHolder) => void;

  formText: FormText<any>;
  formGroup: FormGroup<any>;
  constructor() {}

  ngOnInit(): void {
    this.formGroup = this.fb.group<any>({
      name: this.fb.control<string>(this.entity ? this.entity.name : null, [Validators.required]),
      email: this.fb.control<string>(null, [Validators.email]),
      emails: this.fb.array((this.entity && this.entity.recipientEmailAddressText)
        ? this.entity.recipientEmailAddressText.split(",").map(email => this.fb.control<string>(email)) 
        : [], [Validators.required])
    });
    this.formText = {
      name: {
        label: "Name",
        placeholder: "name",
        errors: {
          required: "The Name field is required"
        },
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-7",
        popoverTitle: "The name is just a field which appears later in the list of profiles. By giving the connection a meaningful name, it is easier to find it later in the list.",
        popover: "The name is just a field which appears later in the list of profiles. By giving the connection a meaningful name, it is easier to find it later in the list."
      },
      email: {
        label: "Recipient Email(s)",
        placeholder: "recipient email address",
        errors: {
          required: "Please enter at least one email address and press Enter",
          email: "Invalid email address. Please make sure it looks like this: email@domain.com"
        },
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-7",
        popover: "The recipients email list.",
        help: "Enter an email address and press Enter"
      }
    };
  }

  sendTestEmail() {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
    } else {
      const holder: IEmailProfileHolder = {
        name: this.formGroup.controls.name.value,
        userName: undefined,
        password: undefined,
        smtpServer: undefined,
        port: undefined,
        useSsl: undefined,
        recipientEmailAddressText: this.formGroup.controls.emails.value.join(",").trim(),
        fromEmailAddress: undefined,
        fromEmailDisplayName: undefined,
        isCurrentlyInUse: false,
        isUsedInConfiguration: false,
        passwordHash: undefined,
        tenantId: undefined,
        scopes: undefined,
        azureClientSecret: undefined,
        azureClientId: undefined,
        azureTenantId: undefined,
        jsonKey: undefined,
        smtpType: SmtpType.BasicAuthentication
      };
      this.sendTestEmailCallback(holder);
    }
  }

  save() {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
    } else {
      const holder: IEmailProfileHolder = {
        name: this.formGroup.controls.name.value,
        userName: undefined,
        password: undefined,
        smtpServer: undefined,
        port: undefined,
        useSsl: undefined,
        recipientEmailAddressText: this.formGroup.controls.emails.value.join(",").trim(),
        fromEmailAddress: undefined,
        fromEmailDisplayName: undefined,
        isCurrentlyInUse: false,
        isUsedInConfiguration: false,
        passwordHash: undefined,
        tenantId: undefined,
        scopes: undefined,
        azureClientSecret: undefined,
        azureClientId: undefined,
        azureTenantId: undefined,
        jsonKey: undefined,
        smtpType: SmtpType.BasicAuthentication
      };
      this.saveCallback(holder);
    }
  }
}
